import { Col, Icon, IconNames, Row, Typography } from '@repo/ui/components'
import { ToDateTime, ValueWithUnit } from '@repo/shared/components'
import { type MessagesKeys, useTranslate } from '@repo/shared/hooks'
import { CSSVariableColor } from '@repo/ui/types/colors'
import { UserOTCOrder, useGetProjectDetails } from '@repo/services'
import { BalanceProjectDetailsDialog } from './balance-project-details.dialog'

const iconMapper: Record<'buy' | 'sell', IconNames> = {
  buy: 'PlusLine',
  sell: 'MinusLine',
}

const iconColorMapper: Record<'buy' | 'sell', CSSVariableColor> = {
  buy: 'fill-positive-surface-100',
  sell: 'fill-negative-surface-100',
}

export const BalanceProjectItem = ({
  data,
  createdAt,
  showCurrency = false,
  projectId,
}: {
  data: UserOTCOrder
  createdAt: string
  showCurrency?: boolean
  projectId: string
}) => {
  const { t } = useTranslate()
  const { orderType, targetAmount, baseAmount, targetCurrency } = data

  const { data: response } = useGetProjectDetails(
    projectId !== 'MALEK' ? projectId : undefined,
  )
  const projectData = response?.data.project || {}

  const title = t(`walletPage_${orderType}` as MessagesKeys)

  return (
    <BalanceProjectDetailsDialog data={data} projectData={projectData}>
      <Row className='justify-between gap-md py-xl cursor-pointer'>
        <Icon
          name={iconMapper[orderType as 'buy' | 'sell']}
          color={iconColorMapper[orderType as 'buy' | 'sell']}
          size='md'
        />
        <Col className='gap-xs item-start text-start cursor-pointer'>
          <Row className='gap-xs flex-wrap max-w-[150px] md:max-w-[unset] items-center'>
            <Typography
              size='sm'
              weight='bold'
              color='text-neutral-surface-100'
            >
              {title}
            </Typography>

            {showCurrency && (
              <Typography
                size='xs'
                weight='regular'
                color='text-neutral-surface-100'
              >
                {targetCurrency}
              </Typography>
            )}
          </Row>
          <ValueWithUnit
            value={baseAmount}
            unit={'TMN'}
            scale={10}
            valueWeight='regular'
          />
        </Col>
        <Col className='items-end gap-xs'>
          <Typography size='xs' color='text-neutral-surface-80' variant='bdi'>
            <ToDateTime date={new Date(createdAt ?? '')} />
          </Typography>
          {/* history: buy and sell tab: type: projects and crypto */}

          {targetCurrency === 'MALEK' ? (
            <ValueWithUnit
              value={targetAmount ?? 0}
              valueSize='sm'
              unitSize='2xs'
              unit={'crypto'}
              valueWeight='bold'
            />
          ) : (
            <ValueWithUnit
              value={targetAmount ?? 0}
              unit={projectData.kind}
              scale={projectData.scale}
            />
          )}
        </Col>
      </Row>
    </BalanceProjectDetailsDialog>
  )
}
